<template>
  <div id="main-nav" class="main-nav-wrap js-main-nav">
    <Container>
      <router-link
        to="/"
        class="main-nav__logo"
        :class="{ 'show-logo': showLogo }"
      >
        <img
          :src="logo.url"
          :alt="logo.alt"
          class="main-nav__logo-img"
          :class="{ minidayz: logo.type === 'minidayz' }"
        />
      </router-link>

      <button
        class="butn main-nav__hamburger"
        aria-label="toggle menu"
        @click="toggleNav()"
        v-html="HamburgerIcon"
      ></button>

      <MainNav
        :navLinks="navLinks"
        :socialLinks="socialLinks"
        :user="user"
        @closeNav="closeNav"
      />
    </Container>

    <!-- SLOT FOR SUB NAVIGATION, USED AT DAYZ project -->
    <slot></slot>
  </div>
</template>

<script>
import Container from "../common/Container";
import MainNav from "./MainNav";
import HamburgerIcon from "../../assets/icons/hamburger.svg";

export default {
  props: {
    logo: Object,
    navLinks: Array,
    socialLinks: Array,
    user: {}
  },
  components: {
    Container,
    MainNav
  },
  data() {
    return {
      stuck: false,
      HamburgerIcon,
      showLogo: false,
      navEl: null,
      headerEl: null
    };
  },
  methods: {
    toggleNav() {
      this.$emit("toggleNav");
    },
    closeNav() {
      this.$emit("closeNav");
    },
    toggleLogo() {
      if (this.navEl.offsetTop > this.headerEl.clientHeight) {
        this.showLogo = true;
      } else {
        this.showLogo = false;
      }
    }
  },
  mounted() {
    this.navEl = document.getElementById("main-nav");
    this.headerEl = document.getElementById("main-header-wrapper");
    window.addEventListener("scroll", this.toggleLogo);
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.butn {
  @include butn;
}

.main-nav-wrap {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 101;
  transition: transform $transitionSlide;

  min-height: $navSize;
  background-color: #47533e;
  text-align: right;

  @media (max-width: $screen-xl) {
    min-height: $navSizeSm;
  }

  @media (max-width: $screen-md) {
    position: fixed;
  }
}

.main-nav__logo {
  opacity: 0;
  float: left;
  line-height: $navSize;
  height: $navSize;
  transition: opacity 0.5s;

  @media (max-width: $screen-xl) {
    line-height: $navSizeSm;
    height: $navSizeSm;
    margin-top: -3px;
    margin-left: 5px;
  }

  @media (max-width: $screen-sm-max) {
    opacity: 1;
  }

  &.show-logo {
    opacity: 1;
  }
}

.main-nav__logo-img {
  width: 90px;
  height: auto;

  @media (max-width: $screen-xl) {
    width: 58px;
  }

  &.minidayz {
    width: 125px;

    @media (max-width: $screen-xl) {
      width: 100px;
    }
  }
}

.main-nav__hamburger {
  display: none;
  position: relative;
  line-height: $navSizeSm;
  height: $navSizeSm;
  font-size: 36px;
  color: $mainRed;

  @media (max-width: $screen-sm-max) {
    display: inline-block;
  }

  @media (max-width: $screen-xs-max) {
    font-size: 29px;
  }
}
</style>

<style lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.main-nav__hamburger svg {
  width: 1em;
  height: 0.6038em;
  fill: currentColor;
}
</style>
